import { useAisIdentity } from './ais/useAisIdentity';
import { NoAccess } from './components/NoAccess';

export const NoAccessRoute = () =>
  useAisIdentity() ? (
    <NoAccess
      subTitle="Für Ihren Zuweiser ist labcomplete® noch nicht freigeschaltet. Bitte wenden Sie sich an medcom."
      showReload={false}
    />
  ) : (
    <NoAccess />
  );
